import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'lodash'

import LoginActions from '../../../actions/LoginActions.js'
import {openMfaPopup} from '../../../components/login/mfaPopup.js'

import {Alert, Colors, H5, Popup, H3, Card, S2} from '../../../components/UI/index.js'
import Address from '../../../components/addresses/Address.js'
import SMTPSettings from '../../../components/settings/SMTPSettings.js'
import {formSpacing, FormRow, FormStack, Input, UploadImage, Toggle} from '../../../components/UI/forms/index.js'

import t from '../../../helpers/Languages.js'

class AccountSettings extends Reflux.Component {
    onChangeLogo(logo) {
        const user = {...this.props.user}

        user.settings.newLogo = logo

        this.props.onChange(user)
    }

    onChangeValue(path, event) {
        const user = {...this.props.user}

        _.set(user.settings, path, event.target.value)

        this.props.onChange(user)
    }

    onChangeChecked(path, event) {
        const user = {...this.props.user}

        if (path === 'mfaRequired') {
            if (!event.target.checked) {
                if (user.settings.mfaRequired) {
                    if (user.mfaMethod === 'email') {
                        LoginActions.mailMFACode(null, user.index, null, (err) => {
                            if (err) {
                                this.popup.setError(err)
                            }
                        })
                    }

                    openMfaPopup(this.popup, {
                        mfaMethod: user.mfaMethod,
                        confirmLabel: 'Bevestig',
                        onLogin: (code) => {
                            LoginActions.verify2FACode(code, (err) => {
                                if (err) {
                                    this.popup.setError(err)
                                } else {
                                    this.popup.close()

                                    _.set(user.settings, path, event.target.checked)

                                    this.props.onChange(user)
                                }
                            })
                        }
                    })
                }
            }

            if (event.target.checked) {
                if (user.mfaEnabled) {
                    _.set(user.settings, path, event.target.checked)

                    this.props.onChange(user)
                } else {
                    this.popup.open('Tweestapsverificatie nog niet ingesteld.', 'Om 2FA te activeren word je nu uitgelogd. Bij opnieuw inloggen zal gevraagd worden om de gewenste 2FA methode te activeren.', () => {
                        _.set(user.settings, path, event.target.checked)

                        this.props.onChange(user, true)

                        // give app the time to save the settings before logging out
                        setTimeout(() => {
                            LoginActions.logout()
                        }, 1000)
                    })
                }
            }
        } else {
            _.set(user.settings, path, event.target.checked)

            this.props.onChange(user)
        }
    }

    onChangeAddress(address) {
        const user = {...this.props.user}

        user.address = address
        user.name = address.name

        this.props.onChange(user)
    }

    render() {
        const {user} = this.props

        return (
            <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                <H3 style={{marginBottom: 36}}>Bedrijfsgegevens</H3>

                <H5 style={{marginBottom: 24, marginTop: 36}}>Inlogbeveiliging</H5>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Toggle
                        label='Tweefactorauthenticatie'
                        checked={user.settings.mfaRequired}
                        onChange={this.onChangeChecked.bind(this, 'mfaRequired')}
                        info='De handleiding voor 2FA is te vinden via het vraagteken-icoon rechtsboven.'
                    />
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 36}}>Logo en kleur</H5>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <UploadImage
                        label={
                            <>
                                Logo
                                <S2 style={{whiteSpace: 'initial'}}>(Maximale bestandsgrootte: 1MB, bestandstype: .png)</S2>
                            </>
                        }
                        image={user.settings.newLogo ?? ((!user.settings.logo || user.settings.logo?.includes('data:image')) ? user.settings.logo : `/${user.settings.logo}`)}
                        onChange={this.onChangeLogo.bind(this)}
                        resize={false}
                        maxSize={1}
                    />

                    {!user.settings.logo &&
                        <Alert variant='info' style={{marginTop: -10, marginBottom: 18, maxWidth: 658}}>Je hebt nog geen logo geupload, dit logo wordt op verschillende plekken gebruikt.</Alert>
                    }

                    <Input
                        type='color'
                        label='Kleur'
                        value={user.settings.color || Colors.brandColor}
                        onChange={this.onChangeValue.bind(this, 'color')}
                    />
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 36}}>Adres</H5>

                <Address
                    noTAV
                    address={user.address || {}}
                    onChange={this.onChangeAddress.bind(this)}
                />

                <FormRow style={{marginTop: formSpacing.section, marginBottom: formSpacing.rowGap}}>
                    <Input
                        label={t('vatNumber')}
                        info='Bij sommige vervoerders moet een geldig BTW nummer en/of EORI nummer meegestuurd worden bij zendingen naar landen waar douane informatie vereist is.'
                        value={user.settings.parcels.vatNumber}
                        onChange={this.onChangeValue.bind(this, 'parcels.vatNumber')}
                    />
                    <Input
                        label={t('eoriNumber')}
                        info='Bij sommige vervoerders moet een geldig BTW nummer en/of EORI nummer meegestuurd worden bij zendingen naar landen waar douane informatie vereist is.'
                        value={user.settings.parcels.eoriNumber}
                        onChange={this.onChangeValue.bind(this, 'parcels.eoriNumber')}
                    />
                </FormRow>

                <H5 style={{marginBottom: 24, marginTop: 36}}>Email instellingen</H5>

                <SMTPSettings
                    settings={user.settings}
                    onChange={this.onChangeValue.bind(this)}
                    onChangeChecked={this.onChangeChecked.bind(this)}
                />

                <Popup confirmLabel='Bevestigen' cancelLabel='Annuleren' ref={(ref) => this.popup = ref} />
            </Card>
        )
    }
}

export default AccountSettings
